export default {
	template: `
        <q-spinner
        color="primary"
        size="4rem"/>

    `,
}
